import { useEffect, useState } from 'react';
import { apiGet } from '@/api/api';

interface UserSessionCount {
  userId: number;
  sessionCount: number;
  hasData: boolean;
}

/**
 * 여러 사용자의 세션 개수를 백그라운드에서 조회하는 Hook
 */
export const useUserSessionCounts = (userIds: number[]) => {
  const [sessionCounts, setSessionCounts] = useState<Map<number, UserSessionCount>>(new Map());
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (userIds.length === 0) return;

    const fetchSessionCounts = async () => {
      setIsLoading(true);
      const counts = new Map<number, UserSessionCount>();

      // 병렬로 모든 사용자의 세션 개수 조회
      const promises = userIds.map(async (userId) => {
        try {
          const response = await apiGet<any>(
            `/protectee/${userId}/mind-health/sessions?status=COMPLETED&pageSize=1`
          );
          
          const totalEntries = response.data?.pagination?.totalEntries || 0;
          
          counts.set(userId, {
            userId,
            sessionCount: totalEntries,
            hasData: totalEntries > 0,
          });
        } catch (error) {
          console.error(`사용자 ${userId}의 세션 조회 실패:`, error);
          counts.set(userId, {
            userId,
            sessionCount: 0,
            hasData: false,
          });
        }
      });

      await Promise.all(promises);
      setSessionCounts(counts);
      setIsLoading(false);
    };

    // 디바운스: 500ms 후에 조회
    const timeoutId = setTimeout(fetchSessionCounts, 500);
    return () => clearTimeout(timeoutId);
  }, [userIds.join(',')]);

  return { sessionCounts, isLoading };
};

